export default {
    category_list:"/api/category_list_readonly/",
    present_list:"/api/present_list_readonly/",
    banner_list_readonly: "/api/banner_list_readonly/", // 轮播图列表
    video_list_readonly: "/api/video_list_readonly/", //视频列表
    review_apply: "/verify/review_apply/", //提交认证
    bulletin_list_readonly: "/api/bulletin_list_readonly/", //公告列表
    question_answer_list_readonly: "/api/question_answer_list_readonly/", //常见问题列表
    question_list_readonly: "/api/question_list_readonly/", //用户问题列表
    send_code: "/qlsms/send/", //发送验证码
    real_live: "/train/real_live/", // 实时直播
    member_apply: "/api/member_apply_list_readonly/", //成员审核详情
    video_list: "/video/user_video_list/", //获取视频列表
    video_apply: "/verify/video_apply/", //视频申请
    member_quiz: "/qa_bot/member_quiz/", //用户提问
    refresh_user: "/account/refresh_user/", //刷新用户信息
    video_apply_list: "/verify/video_apply_list/", //视频申请列表
    personal_center: "/member/personal_center/", //个人中心学习简况
    member_list: "/api/member_list/", //个人信息
    change_phone: "/member/change_phone/", //修改手机号
    user_learn_status: "/member/user_learn_status/", //用户学习状态
    certificate: "/api/certificate/", //证书
    qrcode_list_readonly: "/api/qrcode_list_readonly/", //考试二维码
    member_integral_readonly: "/api/member_integral_readonly/", //积分列表
    change_password: "/member/change_password/", //修改密码
    integral_list: "/api/integral_list/", //积分管理
    trade_pay: "/alipay_util/trade_pay/", //支付
    get_video_detail: "/video/get_video_detail/", //获取视频详情
    add_plays: "/video/add_plays/", //增加播放量
    learn_bar: "/member/learn_bar/", //修改学习进度
    export_cert: "/member/export_cert/", //下载证书
    alipay_order_readonly: "/alipay_util/alipay_order_readonly/", //查询订单状态
    modify_login_password: "/account/modify_login_password/", //修改密码
}
